import { render } from "./ZoomistComp.vue?vue&type=template&id=06d45280&scoped=true"
import script from "./ZoomistComp.vue?vue&type=script&lang=js"
export * from "./ZoomistComp.vue?vue&type=script&lang=js"

import "./ZoomistComp.vue?vue&type=style&index=0&id=06d45280&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d45280"]])

export default __exports__